import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useViewAs } from '../context/ViewAsContext';
import { getRouteGuardRedirect } from '../lib/roleContext';

/**
 * Redirects when the current path is incompatible with effective role (view-as or real).
 */
export default function RoleRouteGuard() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { user, isAdmin } = useAuth();
  const { viewAsRole } = useViewAs();

  useEffect(() => {
    if (!user) {
      return;
    }
    const redirect = getRouteGuardRedirect(pathname, { user, isAdmin, viewAsRole });
    if (redirect && redirect !== pathname) {
      navigate(redirect, { replace: true });
    }
  }, [pathname, user, isAdmin, viewAsRole, navigate]);

  return null;
}
